var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mt-2",attrs:{"fab":"","small":"","color":"#F4F6F8","elevation":"0"},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"color":"#A5ACB4"}},[_vm._v(" mdi-magnify ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }